import { Outlet } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import { AlarmGroupProvider, useAlarmGroupContext } from '_/contexts/AlarmGroupContext';
import DocumentTitle from '_/hooks/DocumentTitle';
import React, { ReactElement } from 'react';

function SelectedAlarmGroupContent(): ReactElement {
  const { selectedAlarmGroup, isLoading } = useAlarmGroupContext();

  DocumentTitle(`${selectedAlarmGroup?.name || 'Alarm Group'} :: ${location.pathname.split('/').pop()}`);

  return (
    <AsyncPageContainer isLoading={isLoading || !selectedAlarmGroup}>
      <Outlet />
    </AsyncPageContainer>
  );
}

function SelectedAlarmGroup(): ReactElement {
  return (
    <AlarmGroupProvider>
      <SelectedAlarmGroupContent />
    </AlarmGroupProvider>
  );
}

export default SelectedAlarmGroup;
